import { render } from "./SingleBlog.vue?vue&type=template&id=bd82751e&scoped=true"
import script from "./SingleBlog.vue?vue&type=script&lang=js"
export * from "./SingleBlog.vue?vue&type=script&lang=js"

import "./SingleBlog.vue?vue&type=style&index=0&id=bd82751e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd82751e"]])

export default __exports__